export const noPropagation = action => e => { e.stopPropagation(); return action(e) }
